// uses splide: https://splidejs.com/guides/getting-started/

import Splide from '@splidejs/splide';

Drupal.behaviors.articleGallery = {
    attach() {
        let sliders = document.querySelectorAll('.mod-articlegallery');
        if (sliders.length) {
            for (var i = 0; i < sliders.length; i++) {
                let splideElement = sliders[i].querySelector("#splide-main");
                const splideDefaultOptions = {
                    type: 'slide',
                    pagination: false,
                    arrows: true,
                    cover: true,
                    rewind: true,
                    i18n: {
                        prev: 'Vorheriges Bild',
                        next: 'Nächstes Bild',
                        first: 'Zum ersten Bild',
                        last: 'Zum letzten Bild',
                    }
                }

                let thumbnailsElement = sliders[i].querySelector("#splide-thumbs");
                const thumbnailsDefaultOptions = {
                    rewind: true,
                    fixedWidth: 120,
                    fixedHeight: 76,
                    isNavigation: true,
                    gap: 16,
                    focus: 'left',
                    pagination: false,
                    cover: true,
                    arrows: false,
                    drag: false
                }

                let splide = new Splide(splideElement, splideDefaultOptions);
                let thumbnails = new Splide(thumbnailsElement, thumbnailsDefaultOptions);

                splide.sync(thumbnails);
                splide.mount();
                thumbnails.mount();

                sliders[i].classList.add('splide--processed');
            }
        }
    },
};